








































































































































































import { defineComponent, computed, ref, PropType, watch } from '@vue/composition-api';
import CreativeNode from './creative-node.vue';
import { AdgroupItem } from '../types';
import MoreActions from './more-actions.vue';
import { CreationStep } from '@tt4b/ttam-enums';

const name = 'ttam-sidebar-adgroup-level-node';
export default defineComponent({
  name,
  components: {
    MoreActions,
    CreativeNode,
  },
  props: {
    curUid: {
      type: String,
      default: '',
    },
    adgroupNum: {
      type: Number,
      default: 1,
    },
    adgroupInfo: {
      type: Object as PropType<AdgroupItem>,
      default: () => ({}),
    },
    itemIndex: {
      type: Number,
      default: 1,
    },
  },
  setup(props, { emit }) {
    const isDraftStatus = computed(() => props.adgroupInfo.adgroupStatus === 'draft');
    const isPublishedStatus = computed(() => props.adgroupInfo.adgroupStatus === 'published');
    const isErrorStatus = computed(() => props.adgroupInfo.adgroupStatus === 'error');
    const isWarningStatus = computed(() => props.adgroupInfo.adgroupStatus === 'warning');
    const isLoadingStatus = computed(() => props.adgroupInfo.adgroupStatus === 'loading');
    const isFinishStatus = computed(() => props.adgroupInfo.adgroupStatus === 'finish');

    const isSmartCreative = computed(() => Boolean(props.adgroupInfo.isSmartCreative));

    const displayArrow = computed(() => props.adgroupInfo.displayArrow ?? true);

    const isActive = computed(() => props.adgroupInfo.adgroupUuid === props.curUid);
    const isSubActive = computed(() => Boolean(props.adgroupInfo.ads?.find(item => item.adUid === props.curUid)));
    const closeArrowInitStatus = computed(() => isActive.value || isSubActive.value);

    const actionConfig = computed(() => props.adgroupInfo.actionConfig || []);

    const adNum = computed(() => props.adgroupInfo.ads.length);
    const adPublishedNum = computed(
      () =>
        props.adgroupInfo.ads.filter(
          item => item.adStatus === 'published' || item.adStatus === 'finish' || item.adStatus === 'acopublished',
        ).length,
    );
    const adErrorNum = computed(() => props.adgroupInfo.ads.filter(item => item.adStatus === 'error').length);

    const adInfos = computed(() => props.adgroupInfo.ads);

    const showMoreIcon = ref(false);
    const showIcon = computed(() => isActive.value || showMoreIcon.value);
    const showAddIcon = computed(() =>
      actionConfig.value.find(item => item.eventName && item.eventName === 'copy-adgroup'),
    );

    const addIconEffect = computed(() => (showAddIcon.value?.disabled ? 'light' : 'dark'));

    const addIconHint = computed(() => {
      const { disabled, disabledHint, name: iconHint } = showAddIcon.value;
      return disabled ? disabledHint : iconHint;
    });

    const addIconPlacement = computed(() => (showAddIcon.value?.disabled ? 'right' : 'top'));

    function handleMouseEnter() {
      showMoreIcon.value = true;
    }

    function handleMouseLeave() {
      showMoreIcon.value = false;
    }

    /** Adgroup 展开/折叠状态 */
    const isClose = ref(!closeArrowInitStatus.value && props.adgroupNum > 1);
    function handleAdgroupExpandChange() {
      isClose.value = !isClose.value;
      emit('expand-adgroup', props.adgroupInfo.adgroupUuid, !isClose.value);
    }

    watch(
      () => [isActive.value, isSubActive.value],
      () => {
        if (isActive.value || isSubActive.value) {
          isClose.value = false;
        }
      },
    );

    /**
     * 处理 Select
     */
    function handleAdgroupSelect() {
      if (props.adgroupInfo.disabled || isFinishStatus.value || isActive.value) {
        return;
      }
      emit('select', 'adgroup', props.adgroupInfo.adgroupUuid);
    }

    function handleCreativeSelect(uid: string) {
      if (props.adgroupInfo.disabled) {
        return;
      }
      emit('select', 'creative', uid);
    }

    /**
     * 处理 Action 事件
     */
    function handleAdgroupEventClick(eventName: string, isShortcutTrigger = false) {
      // 统一处理一下 disabled/loading
      const actionItem = actionConfig.value.find(item => item.eventName && item.eventName === eventName);
      if (actionItem?.disabled || actionItem?.loading) {
        return;
      }
      emit('action', 'adgroup', eventName, {
        campaignUuid: props.adgroupInfo.campaignUuid,
        adgroupUuid: props.adgroupInfo.adgroupUuid,
        adgroupIndex: props.itemIndex,
        isShortcutTrigger,
      });
    }

    function handleMoreBtnClick() {
      emit('action', 'adgroup', 'more-btn-click', {
        campaignUuid: props.adgroupInfo.campaignUuid,
        adgroupUuid: props.adgroupInfo.adgroupUuid,
        adgroupIndex: props.itemIndex,
      });
    }

    function handleCreativeEventClick(eventName: string, data: { adUid: string; adIndex: number }) {
      emit('action', 'creative', eventName, {
        campaignUuid: props.adgroupInfo.campaignUuid,
        adgroupUuid: props.adgroupInfo.adgroupUuid,
        adgroupIndex: props.itemIndex,
        ...data,
      });
    }

    function goToListPage(level: CreationStep, uuid: string) {
      emit('goToListPage', level, uuid);
    }

    return {
      name,
      isActive,
      isSubActive,
      closeArrowInitStatus,
      isSmartCreative,

      isClose,
      isDraftStatus,
      isPublishedStatus,
      isErrorStatus,
      isWarningStatus,
      isLoadingStatus,
      isFinishStatus,
      showIcon,
      showAddIcon,

      displayArrow,
      addIconEffect,
      addIconHint,
      addIconPlacement,
      actionConfig,
      adInfos,
      adNum,
      adPublishedNum,
      adErrorNum,

      handleMouseEnter,
      handleMouseLeave,
      handleAdgroupExpandChange,
      handleAdgroupSelect,
      handleCreativeSelect,
      handleAdgroupEventClick,
      handleMoreBtnClick,
      handleCreativeEventClick,
      goToListPage,
      CreationStep,
    };
  },
});
